import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, doc, query, orderBy, getDoc } from "firebase/firestore";

const SubscriptionsPage = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [pets, setPets] = useState({}); // Pet verileri
  const [products, setProducts] = useState({}); // Ürün verileri
  const navigate = useNavigate(); // 🔥 Navigasyon için

  useEffect(() => {
    const fetchSubscriptionsAndRelatedData = async () => {
      try {
        // 🔥 Abonelikleri çek
        const subsQuery = query(collection(db, "subscriptions"), orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(subsQuery);
        const subscriptionsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSubscriptions(subscriptionsData);

        // 🔥 Petleri çek
        const petIds = new Set(subscriptionsData.flatMap((sub) => sub.selectedPets || []));
        const petsData = {};
        for (let petId of petIds) {
          const petRef = doc(db, "pets", petId);
          const petSnapshot = await getDoc(petRef);
          if (petSnapshot.exists()) {
            petsData[petId] = petSnapshot.data();
          }
        }
        setPets(petsData);

        // 🔥 Ürünleri çekme işlemi
        const productIds = new Set();
        subscriptionsData.forEach((sub) => {
          if (sub.selectedProducts) {
            Object.values(sub.selectedProducts).forEach((productArray) => {
              productArray.forEach((productId) => {
                productIds.add(productId);
              });
            });
          }
        });


        const productsData = {};
        for (let productId of productIds) {
          const productRef = doc(db, "products", productId);
          const productSnapshot = await getDoc(productRef);
          if (productSnapshot.exists()) {
            productsData[productId] = productSnapshot.data();
          }
        }
        setProducts(productsData);
      } catch (error) {
      }
    };

    fetchSubscriptionsAndRelatedData();
  }, []);

  const handleStatusChange = async (subId, status) => {
    try {
      const subRef = doc(db, "subscriptions", subId);
      await updateDoc(subRef, { paymentStatus: status });

      setSubscriptions((prevSubscriptions) =>
        prevSubscriptions.map((sub) =>
          sub.id === subId ? { ...sub, paymentStatus: status } : sub
        )
      );
    } catch (error) {
    }
  };

  return (
    <div>
      <h2>Abonelikler</h2>
      <button onClick={() => navigate("/orders")}>Siparişlere Git</button> {/* 🔥 Orders'a Git Butonu */}

      {subscriptions.length === 0 ? <p>No subscriptions available.</p> : null}

      {subscriptions.map((sub) => {
        // 🐾 Pet isimlerini çek
        const petNames = sub.selectedPets
          ? sub.selectedPets
              .map((petId) => {
                const pet = pets[petId];
                return pet ? pet.name : "No pet info";
              })
              .filter(Boolean) // Boş değerleri temizle
          : [];

        // 🛍 Ürün isimlerini çek (DOĞRU EŞLEME YAPILDI!)
        let productNames = [];
        if (sub.selectedProducts) {
          Object.values(sub.selectedProducts).forEach((productArray) => {
            productArray.forEach((productId) => {


              const product = products[productId]; // ✅ DOĞRU ERİŞİM
              if (product && product.name) {
                productNames.push(product.name);
              }
            });
          });
        }



        return (
          <div key={sub.id} style={{ border: "1px solid black", padding: "10px", margin: "10px 0" }}>
            <p><strong>Petler:</strong> {petNames.length > 0 ? petNames.join(", ") : "No pet info"}</p> {/* Pet isimlerini listeleme */}
            
            {/* 📍 Şehir ve İlçe bilgisi eklendi */}
            <p><strong>Adres:</strong> {sub?.selectedAddress?.fullAddress || "No address available"}</p>
            <p><strong>Şehir:</strong> {sub?.selectedAddress?.city || "Unknown city"}</p>
            <p><strong>İlçe:</strong> {sub?.selectedAddress?.district || "Unknown district"}</p>
            
            <p><strong>Başlangıç:</strong> {sub.createdAt?.seconds ? new Date(sub.createdAt.seconds * 1000).toLocaleDateString() : "Geçersiz Tarih"}</p>
            <p><strong>Bitiş:</strong> {sub.endingAt?.seconds ? new Date(sub.endingAt.seconds * 1000).toLocaleDateString() : "Geçersiz Tarih"}</p>

<p><strong>Ürünler:</strong></p>
<ul>
  {products && Object.keys(products).length > 0 
    ? Object.values(products).map((p, index) => (
        <li key={index}>{p.Name}</li>
      ))
    : <li>No product info</li>}
</ul>

            {/* 📌 Abonelik Durumu Seçimi */}
            <label>
              <input
                type="radio"
                name={`status-${sub.id}`}
                checked={sub.paymentStatus === "Paid"}
                onChange={() => handleStatusChange(sub.id, "Paid")}
              />
              Paid
            </label>
            <label>
              <input
                type="radio"
                name={`status-${sub.id}`}
                checked={sub.paymentStatus === "Pending"}
                onChange={() => handleStatusChange(sub.id, "Pending")}
              />
              Pending
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionsPage;
